<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-05-27 16:18:14
 * @FilePath: \gcp-fe\src\app\shop\components\notice-list.vue
 * @Description: 业务公告
-->
<template>
  <div class="wrapper">
    <div class="ccui-app-container">
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleList="handleList"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
        >
          <!--列表中的插槽Begin-->
          <template slot="title" slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="check(row)"
            >
              {{ row[title] }}
            </el-button>
          </template>
          <!--列表中的插槽End-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth } from "@/setting/setting";
import { queryPublishedNoticeList } from "@/app/shop/api/shoppingSP";
import moment from "moment";
// import $t from "@/app/shop/utils/translateUtil";
export default {
  name: "NoticeList",
  mixins: [mixinListCommon],
  props: {
    rowsField: {
      type: String,
      default: "rows"
    },
    title: {
      type: String,
      default: "title"
    },
    noticeType: {
      type: Number,
      default: 0
    },
    noticeTime: {
      type: Array,
      default: () => []
    },
    noticeTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      isSelection: false,
      formData: {},
      formDataSearch: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      unfixedTableThead: Object.freeze([
        {
          label: this.$t("page.content.serialNo"),
          prop: "id",
          type: "index",
          width: this.$TW.serialNoWidth,
          checked: true
        },
        {
          label: this.$t("page.content.title"),
          prop: "title",
          checked: true,
          width: 500,
          slot: "title"
        },
        {
          label: this.$t("page.content.publishTime"),
          prop: "publishTime",
          width: commonTableWidth.dateTimeWidth,
          checked: true
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      otherParams: {
        module: 1,
        pageState: 2,
        appId: 100123
      }
    };
  },
  methods: {
    // $t, // 移植代码存在国际化方案临时解决
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.formDataSearch = {};
      this.tableName = this.tableList.viewMoreList;
    },
    handleList() {
      // 分页操作列表
      this.getNoticeList();
    },
    getNoticeList() {
      let param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowPageLoading: true,
        // noticeTitle: this.noticeTitle,
        title: this.noticeTitle
      };
      if (this.noticeTime && this.noticeTime.length !== 0) {
        this.formDataSearch.publishStartTime = this.noticeTime[0];
        this.formDataSearch.publishEndTime = this.noticeTime[1];
      } else {
        this.formDataSearch.publishStartTime = null;
        this.formDataSearch.publishEndTime = null;
      }
      param.textType = "3";
      Object.assign(param, this.formDataSearch, this.otherParams);
      this.$delete(param, "publishTime");
      queryPublishedNoticeList(param).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data[this.rowsField].map(item => {
            item.publishTime = item.publishTime
              ? moment(item.publishTime).format("YYYY-MM-DD HH:mm")
              : "";
            return item;
          });
          this.pageTotal = res.data.data.recordsTotal;
        }
      });
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.getNoticeList();
    },
    //查看
    check(row) {
      let url = this.$router.resolve({
        path: "/announcementDetail",
        query: {
          ...this.$route.query,
          id: row.noticeInfoId,
          type: this.type
        }
      });
      window.open(url.href, "_blank");
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  },
  mounted() {
    this.getNoticeList();
  },
  watch: {
    noticeTime: {
      handler(val) {
        this.pageNo = 1;
        this.getNoticeList();
      }
    },

    noticeTitle: {
      handler(val) {
        // console.log(val, "val");
        this.pageNo = 1;
        this.getNoticeList();
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
